import { render, staticRenderFns } from "./CompanyContactsTable.vue?vue&type=template&id=720ce5ce&"
import script from "./CompanyContactsTable.vue?vue&type=script&lang=ts&"
export * from "./CompanyContactsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports